import { ContentPage } from '../components/content-page';
import { ProductList } from '../components/products/product-list';
import { ProductDescription } from '../components/products/product-description';
import { ProductsDataProvider, useProducts } from '../providers/products-provider';
import { useLocation } from 'react-router-dom';
import { PageMetadata } from '../components/page-metadata';

function ProductsPageMetadata() {
    const { selectedCourse, loading, error } = useProducts();
    return <PageMetadata catalogueRecord={!loading && !error && selectedCourse ? {
        key: selectedCourse.course_key, name: selectedCourse.name, description: selectedCourse.description ?? ''
    } : null} />;
}

export default function ProductsPage() {
    const { search } = useLocation();
    const hasSelectedCourse = !!new URLSearchParams(search).get('course');
    return (
        <ProductsDataProvider>
            <ProductsPageMetadata />
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: 0 }}>
                <ContentPage
                    pageId="products"
                    pageTitle="Products"
                    pageTitleLevel="h1"
                    publicPageTitle
                    leftPanelTitle="Available products"
                    rightPanelTitle="Product overview and details"
                    mobileTabs
                    initialMobilePanel={hasSelectedCourse ? 'right' : 'left'}
                    leftContent={(showDetails) => <ProductList onCourseSelected={showDetails} />}
                    rightContent={(showList) => <ProductDescription onBackToList={showList} />}
                    leftContentPercent={40}
                />
            </div>
        </ProductsDataProvider>
    );
}
